import type {WorkBook, WorkSheet, WritingOptions, XLSX$Utils} from 'xlsx';
import {loadXLSX} from '@/resource/js';

declare global {
  interface Window {
    XLSX: {
      utils: XLSX$Utils;
      writeFile: (data: WorkBook, filename: string, opts?: WritingOptions) => any;
    };
  }
}

export async function exportExcelFromJsonData(jsonData: any[], fileName: string, sheetName: string) {
  return exportExcel(() => window.XLSX.utils.json_to_sheet(jsonData), fileName, sheetName);
}

export function exportExcelFromAoaData(aoaData: any[][], fileName: string, sheetName: string) {
  return exportExcel(() => window.XLSX.utils.aoa_to_sheet(aoaData), fileName, sheetName);
}

async function exportExcel(wsFun: () => WorkSheet, fileName: string, sheetName: string) {
  await loadXLSX();
  const {utils, writeFile} = window.XLSX;
  const wb = utils.book_new();
  utils.book_append_sheet(wb, wsFun(), sheetName.slice(0, 31));

  const bookType = fileName.endsWith('.csv') ? 'csv' : 'xls';
  writeFile(wb, fileName, {bookType});
}
